import { render, staticRenderFns } from "./ListItemChoose.vue?vue&type=template&id=154dedf7&scoped=true"
import script from "./ListItemChoose.vue?vue&type=script&lang=js"
export * from "./ListItemChoose.vue?vue&type=script&lang=js"
import style0 from "./ListItemChoose.vue?vue&type=style&index=0&id=154dedf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154dedf7",
  null
  
)

export default component.exports